/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminGetThermostatControlPathParameters } from 'api/actions/admin-get-thermostat-control/admin-get-thermostat-control-path-parameters';
import { AdminGetThermostatControlResponse } from 'api/actions/admin-get-thermostat-control/admin-get-thermostat-control-response';

type AdminGetThermostatControlQueryParameters = Record<string, any>;

/**
 * The path of the AdminGetThermostatControl action.
 */
export const adminGetThermostatControlActionPath = new SweetPath<keyof AdminGetThermostatControlPathParameters>(
  '/admin/custom/thermostat-control',
  { path: '{param}' }
);

/**
 * Creates a contextualized AdminGetThermostatControl actions.
 */
export default function createAdminGetThermostatControlAction(axios: AxiosInstance) {
  return function adminGetThermostatControlAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: AdminGetThermostatControlQueryParameters } = {}) {
    const path = adminGetThermostatControlActionPath.original;

    return axios.get<AdminGetThermostatControlResponse, AdminGetThermostatControlResponse>(path, {
      params: query,
      headers,
    });
  };
}
